import React from 'react';
import { InactiveConversation } from '../styled';
import ReactButton from 'components/Buttons/ReactButton';

export const MessageSendingBlockerCustomerInactive = ({
  showButtonSendMessage = true,
  onClick
}) => {
  return (
    <InactiveConversation>
      <h3>Cliente não está ativo!</h3>
      <span>
        Você ainda pode enviar mensagem, o cliente será ativado quando responder
        a mensagem.
      </span>
      {showButtonSendMessage && (
        <ReactButton color="primary" onClick={onClick} type="button">
          Enviar mensagem
        </ReactButton>
      )}
    </InactiveConversation>
  );
};
